import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

declare global { interface Window { gtag?: (...args: any[]) => void; } }

export const PageTracker: React.FC = () => {
  const location = useLocation();

  useEffect(() => {
    const id = requestAnimationFrame(() => {
      if (typeof window.gtag === 'function') {
        window.gtag('event', 'page_view', {
          page_path: location.pathname + location.search,
          page_title: document.title,
          page_location: window.location.href,
        });
        // console.log('[GA4] page_view:', document.title, location.pathname);
      }
    });
    return () => cancelAnimationFrame(id);
  }, [location]);

  return null;
};
